"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core");
const react_redux_1 = require("react-redux");
const expertsSlice_1 = require("../../../../../../../redux/slices/expertsSlice");
const modalsSlice_1 = require("../../../../../../../redux/slices/modalsSlice");
require("./licenses.scss");
const PlusIcon_1 = __importDefault(require("../../../../../../../svgIcons/PlusIcon"));
const Licenses = (props) => {
    const { expert } = props;
    const { certs } = expert.blocks;
    const [anchorEl, setAnchorEl] = react_1.default.useState(null);
    const handleClick = (event) => setAnchorEl(event.currentTarget);
    const handleSelect = (type) => {
        if (type) {
            props.addDraftLicense(certs.length);
            props.triggerModal({
                key: `experts.${type}`, val: true
            });
        }
        setAnchorEl(null);
    };
    return expert ? (react_1.default.createElement(core_1.Paper, { className: 'paper admin-blocks licenses', square: true },
        react_1.default.createElement("div", { className: "header-add" },
            react_1.default.createElement("h5", { className: "mb-0" }, "Bar Numbers & Certificates"),
            react_1.default.createElement("div", { className: 'align-right' },
                react_1.default.createElement(core_1.Button, { className: "v2-btn-icon-link ", onClick: handleClick, variant: 'text', startIcon: react_1.default.createElement(PlusIcon_1.default, null), disableRipple: true }, "Add"),
                react_1.default.createElement(core_1.Menu, { elevation: 5, id: "simple-menu", anchorEl: anchorEl, keepMounted: true, open: Boolean(anchorEl), onClose: handleSelect, anchorOrigin: { vertical: "bottom", horizontal: "center" }, transformOrigin: { vertical: "top", horizontal: "center" }, PaperProps: {
                        style: {
                            marginTop: "40px"
                        }
                    } },
                    react_1.default.createElement(core_1.MenuItem, { onClick: () => handleSelect('license') }, "Bar Number"),
                    react_1.default.createElement(core_1.MenuItem, { onClick: () => handleSelect('certificate') }, "Certificate")))),
        (certs === null || certs === void 0 ? void 0 : certs.length) ? react_1.default.createElement("ul", { className: 'licenses-list', style: { flexDirection: 'column' } }, certs.filter(v => !v.deleted).map((license, index) => {
            return (react_1.default.createElement("li", { key: index, style: { display: 'flex', flex: 1 } },
                react_1.default.createElement("div", null,
                    license.type === 'license' && react_1.default.createElement(react_1.Fragment, null,
                        react_1.default.createElement("p", null,
                            "Bar Number ",
                            license.license_id,
                            ", ",
                            license.state)),
                    license.type === 'certificate' && react_1.default.createElement(react_1.Fragment, null,
                        react_1.default.createElement("p", null,
                            "Certified ",
                            license.title,
                            " ",
                            license.license_id))),
                react_1.default.createElement("div", { className: 'align-right', style: { flex: 1, alignItems: 'center', paddingTop: '5px' } },
                    react_1.default.createElement("div", { style: { cursor: 'pointer' }, onClick: () => {
                            props.editLicense({ index, license });
                            props.triggerModal({ key: `experts.${license.type}`, val: true });
                        }, className: "edit-data" }))));
        })) : react_1.default.createElement("p", null, "Please add Bar Number and Certificate information to complete your profile."))) : (react_1.default.createElement(react_1.Fragment, null));
};
const mapStateToProps = (state) => {
    const { experts } = state;
    return {
        expert: experts.editableExpert || experts.expert
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        editExpert: (data) => dispatch(expertsSlice_1.editExpert(data)),
        editLicense: (data) => dispatch(expertsSlice_1.editLicense(data)),
        addDraftLicense: (length) => dispatch(expertsSlice_1.addDraftLicense(length)),
        triggerModal: (data) => dispatch(modalsSlice_1.triggerModal(data)),
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(Licenses);
